import React, {Component} from 'react';
import {connect} from 'react-redux';
import TestView from '../components/tests/TestView'
import {retrieveTestsInRange, updateTest, clearDataError} from '../actions/index'
import {Grid, Row, Col/*, Popover, Overlay*/} from 'react-bootstrap'
import CancelTestModal from '../components/tests/CancelTestModal'
import _ from 'lodash'
import Load from '../components/Load'
import refresh from '../../resources/images/refresh.png'
import {statuses, userIsAdmin, userIsGroupAdmin, daysAgo, userIsCialIT} from '../constants'
import Measure from 'react-measure';

let testsUpdateTimer = undefined

class TestsContainer extends Component {

    constructor(props) {
        super(props)

        this.state = {
            showAllTests: undefined,
            didRetrieveAllGroups: false
        }
    }

    componentWillMount() {
        //console.log('TestsContainer', this.props)
        this.refresh(false)

        const admin = userIsAdmin(this.props.user)
        const teamAdmin = userIsGroupAdmin(this.props.user)
        const cialIT = userIsCialIT(this.props.user);

        if (admin) {
            this.props.retrieveAllGroups()
        }

        this.setState({
            showAllTests: admin || cialIT, //can be set false
            didRetrieveAllGroups: admin,
            admin: admin,
            teamAdmin: teamAdmin,
            cialIT: cialIT
        })

        testsUpdateTimer = window.setInterval(this.refreshTests, 1000*5*60)
    }

    componentWillUnmount() {
        window.clearTimeout(testsUpdateTimer);
    }

    refreshTests = () => {
        this.refresh(false)
    }

    refresh = (showNotification) => {
        this.props.dispatch(retrieveTestsInRange(null, null, showNotification))
        this.props.refreshBudget()
    }

    optionsClick = (test,e) => {
        //console.log(e, e.nativeEvent)
        this.setState({
            showOptionsPopover: true,
            optionsTest: test,
            popoverTarget: e.target,
            popoverX: e.nativeEvent.clientX,
            popoverY: e.nativeEvent.clientY,
        })
    }

    editTest = (test, completing) => {
        this.props.dispatch(clearDataError('createTest'))
        this.props.dispatch(clearDataError('updateTest'))
        this.props.editTest(test, completing)
        this.setState({
            showCancelTestModal: false,
            showOptionsPopover: false
        })
    }

    showCancelTest = () => {
        //console.log('cancelTest', test)
        this.setState({
            showCancelTestModal: true,
            showOptionsPopover: false
        })
    }

    cancelTest = () => {
        if (this.state.optionsTest) {
            this.props.dispatch(updateTest(this.state.optionsTest.id, {status: statuses.CANCELLED}))
            this.setState({
                showCancelTestModal: false,
                showOptionsPopover: false
            })
        }
    }

    closePopover = () => {
        this.setState({showOptionsPopover: false})
    }

    showAllTestsClick = () => {
        if (!this.state.didRetrieveAllGroups) {
            this.props.retrieveAllGroups()
            this.setState({didRetrieveAllGroups: true})
        }
        this.setState({showAllTests: !this.state.showAllTests})
    }

    testInGroupForTeamAdmin = (t) => {
        return this.state.teamAdmin && t.group === (this.props.group || {}).id
    }

    render() {

        //console.log('TestsContainer render', this.props)

        return <div className="tests-container">

            <Grid fluid>
                <Row>
                <Col  xs={2} className="align-left" style={{paddingLeft: '4px'}} >
                    {(this.props.loading || {}).retrieveGroup ? <Load /> : (this.props.group || {}).name || ''}
                </Col>
                <Col  xs={10} className="align-right" >

                    <button className="inline-block link no-underline" style={{marginRight:'10px'}} onClick={this.showAllTestsClick}>
                        {`${this.state.showAllTests ? 'Hide' : 'Show'} all tests`}
                    </button>


                    <button className="inline-block link no-underline" onClick={() => this.refresh(true)}>
                        <img src={refresh} alt="" style={{width: '16px', height: '14px', marginRight: '6px'}}/>
                        Refresh view
                    </button>
                </Col>
                </Row>
            </Grid>

            {(this.props.loading || {}).createTest && <Load />}

            <Measure>
                {dimensions => {
                    const compact = dimensions.width < 460
                    return <Grid fluid>

                    <Row className="test-grid-header">
                        <Col xs={1}>
                            REF
                        </Col>
                        <Col xs={2}>
                            {compact ? 'DATE' : 'DATE/TIME'}
                        </Col>
                        <Col xs={this.state.showAllTests ? 1 : 2}>
                            {compact ? 'SCHEDULER' : 'SCHEDULER NAME'}
                        </Col>
                        {this.state.showAllTests && <Col xs={1}>
                            {compact ? 'AGENCY' : 'AGENCY'}
                        </Col>}
                        <Col xs={1}>
                            {compact ? 'TYPE' : 'AIRCRAFT TYPE'}
                        </Col>
                        <Col xs={1}>
                            {compact ? 'REG.' : 'A/C REGISTRATION'}
                        </Col>
                        <Col xs={1}>
                            {compact ? 'POWER' : 'MAX POWER TESTED'}
                        </Col>
                        <Col xs={2}>
                            {compact ? 'DEPART' : 'SCHD. DEPARTURE TIME'}
                        </Col>
                        <Col xs={2}>
                            {compact ? 'STATUS' : 'TEST STATUS'}
                        </Col>
                    </Row>

                    {this.props.tests.length === 0 && (
                        (this.props.loading || {}).retrieveTestsInRange  ? <Load /> : <Row>
                        <Col xs={12}>
                            No tests in given time period
                        </Col>
                    </Row>)}

                    {this.props.tests.filter(t => this.state.showAllTests ||
                        (t.owner === (this.props.user || {}).id) ||
                        this.testInGroupForTeamAdmin(t)).map(test => {
                        //console.log('tv', key, this.props.tests[key])
                        return <TestView
                            key={test.id}
                            test={test}
                            compact={compact}
                            showOptions={this.state.admin ||
                                (test.owner === (this.props.user || {}).id && test.status === statuses.SCHEDULED) ||
                                (this.testInGroupForTeamAdmin(test) && test.status === statuses.SCHEDULED)}
                            optionsClick={this.optionsClick}
                            thisTestUnderBudget={_.first(_.filter(this.props.underBudgetTests, id => id === test.id))}
                            overBudget={this.props.overBudget}
                            showGroups={this.state.showAllTests}
                            groups={this.props.groups}
                        />
                    })}


                </Grid>}}
            </Measure>

            {/*this.state.optionsTest && <TestOptionsModal
                test={this.state.optionsTest}
                completeTest={this.completeTest}
                cancelTest={this.cancelTest}
            />*/}


            {/*<Overlay
                show={this.state.showOptionsPopover}
                target={this.state.popoverTarget}
                placement="left"
                container={this}
                containerPadding={20}
            >

                <Popover id="popover-contained">
                    <div style={{zIndex: '2'}}>
                        <div>
                            <button onClick={() => {this.editTest(this.state.optionsTest)}} className='test-options'>Edit Test</button>
                        </div>
                        <div>
                            <button onClick={() => {this.completeTest(this.state.optionsTest)}} className='test-options'>Complete Test</button>
                        </div>
                        <div>
                            <button onClick={() => {this.showCancelTest()}} className='test-options'>Cancel Test</button>
                        </div>
                        <div>
                            <button onClick={this.closePopover} className='test-options'>Close</button>
                        </div>
                    </div>
                    <div  style={{zIndex: '1'}}>
                        <button style={{
                            //zIndex: '1',
                            //position: 'absolute',
                            width: '8000px',
                            height: '8000px',
                            top: '-4000px',
                            left: '-4000px',
                            backgroundColor: 'red',
                            border: 'solid transparent 0px'
                        }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.closePopover()
                            }} />
                    </div>
                </Popover>*/}

            {this.state.showOptionsPopover &&
                <div>
                    {/*console.log('target', this.state.popoverTarget, this.state.popoverX,  this.state.popoverY)*/}

                    <div className="popover-content" style={{
                        border: 'solid 1px white',
                        zIndex: '2',
                        position: 'fixed',
                        top: this.state.popoverY - 50,
                        left: this.state.popoverX - 85,
                        padding: '5px'
                    }}>

                        {this.state.admin ?
                            <div>
                                <div>
                                    <button onClick={() => {this.editTest(this.state.optionsTest, false)}} className='test-options'>Edit Test</button>
                                </div>
                                <div>
                                    < button onClick={() => {this.editTest(this.state.optionsTest, true)}} className='test-options'>Complete Test</button>
                                </div>
                                <div>
                                    <button onClick={() => {this.showCancelTest()}} className='test-options'>Cancel Test</button>
                                </div>
                            </div> :
                            <div>
                                <div>
                                    <button onClick={() => {this.editTest(this.state.optionsTest, false)}} className='test-options'>Edit Test</button>
                                </div>
                                <div>
                                    < button onClick={() => {this.editTest(this.state.optionsTest, true)}} className='test-options'>Complete Test</button>
                                </div>
                                <div>
                                    <button onClick={() => {this.showCancelTest()}} className='test-options'>Cancel Test</button>
                                </div>
                            </div>
                        }
                        {/*<div>
                            <button onClick={this.closePopover} className='test-options'>Close</button>
                        </div>*/}
                    </div>
                    <div
                        style={{zIndex: '1',
                            position: 'fixed',
                            width: '100%',
                            height: '100%',
                            top: '0px',
                            left: '0px',
                            backgroundColor: 'transparent',
                            border: 'solid transparent 0px'
                        }}
                        onClick={(e) => {
                            e.preventDefault()
                            this.closePopover()
                        }}
                    />
                </div>}

            {this.state.showCancelTestModal && <CancelTestModal
                onOk={this.cancelTest}
                onCancel={() => this.setState({showCancelTestModal: false})}/> }

        </div>
    }
}

TestsContainer = connect((state,props) => {

    const admin = userIsAdmin(props.user)
    const teamAdmin = userIsGroupAdmin(props.user)
    const cialIT = userIsCialIT(props.user);
    //console.log('TestsContainer', props, state, admin, teamAdmin, (state.data || {}).tests)

    return {
        //tests: _.filter(_.reverse(_.sortBy(_.values((state.data || {}).tests || {}), 'startedAt')), test =>  (test.status !== statuses.CANCELLED && test.status !== statuses.DELETED))
        tests: _.chain((state.data || {}).tests || {})
            .values()
            .sortBy('startedAt')
            .reverse()
            .filter(test => (test.owner === (props.user || {}).id && (test.status !== statuses.CANCELLED || (daysAgo(test.startedAt) || 0) < 4)) ||
                ((admin || teamAdmin || cialIT) && (test.status !== statuses.CANCELLED || (daysAgo(test.startedAt) || 0) < 4)) ||
                (test.status !== statuses.CANCELLED && test.status !== statuses.DELETED))
            .value()
    }
})(TestsContainer);

export default TestsContainer








// WEBPACK FOOTER //
// ./src/containers/TestsContainer.jsx